import React from 'react';
import { Text, Flex, styled } from '@goodrx/matisse';
import { Checkbox } from 'app/components/SignupFormCheckbox';
import { LegalLink } from 'app/components/links/LegalLink/LegalLink';
import { LegalCodes } from '@goodrx/heydoctor-core';
import { CoreLink } from 'app/components/core';

const StyledCoreLink = styled(CoreLink)`
  color: ${(p) => p.theme.colors.primary};
  font-weight: 500;
`;

export const HmaCheckbox: React.FC<{
  value: boolean;
  onChange: (field: string, value: boolean) => void;
  onLearnMoreClick?: () => void;
  useNextLinks?: boolean;
}> = ({ value, onChange, onLearnMoreClick, useNextLinks }) => (
  <Flex flexDirection="column">
    <Checkbox
      id="hma-consent"
      name="consentedToHma"
      value={value}
      onChange={onChange}
      label={
        <Text lineHeight="22px">
          I agree to the{' '}
          {useNextLinks ? (
            <StyledCoreLink
              href={`/legals/${LegalCodes.HIPAAMarketingAuthorization}`}
              target="_blank"
              rel="noopener noreferrer">
              GoodRx HIPAA Marketing Authorization
            </StyledCoreLink>
          ) : (
            <LegalLink
              to={`/legals/${LegalCodes.HIPAAMarketingAuthorization}`}
              target="_blank"
              rel="noopener noreferrer">
              GoodRx HIPAA Marketing Authorization
            </LegalLink>
          )}
        </Text>
      }
    />

    <Text as="p" color="greyDarkest" mt={1} mb={0} ml="26px" fontSize={14} onClick={onLearnMoreClick}>
      This is optional –{' '}
      <Text
        fontWeight={400}
        color="greyDarkest"
        style={onLearnMoreClick && { textDecoration: 'underline', cursor: 'pointer' }}>
        get free coupons and medicine prices
      </Text>
    </Text>
  </Flex>
);
